import { useEffect, useState } from "react";
import axios from "axios";
import { Quote } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/site/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Testimonials() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/testimonials`)
      .then((r) => setItems(r.data))
      .catch(() => setItems([]));
  }, []);

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="scroll-mt-20 border-t border-[#2a2a2a] bg-[#050505] py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="mb-14 max-w-3xl">
          <Reveal><Eyebrow>In their words</Eyebrow></Reveal>
          <Reveal i={1}>
            <h2 className="mt-4 font-display text-4xl font-semibold leading-[1.02] tracking-tighter text-[#f5f5f0] sm:text-5xl lg:text-6xl">
              Discreet, dependable, defensible.
            </h2>
          </Reveal>
        </div>

        <div className="hairline-grid grid grid-cols-1 gap-px border border-[#2a2a2a] md:grid-cols-3">
          {items.map((t, i) => (
            <Reveal
              key={t.id}
              i={i}
              data-testid={`testimonial-${t.id}`}
              className="flex flex-col justify-between p-6 md:p-8"
            >
              <div>
                <Quote className="h-6 w-6 text-[#c4a962]" strokeWidth={1.5} />
                <p className="mt-5 text-sm leading-relaxed text-[#c9c9c2] md:text-[15px]">
                  “{t.quote}”
                </p>
              </div>
              <div className="mt-6 border-t border-[#2a2a2a] pt-4">
                <div className="font-display text-base tracking-tight text-[#f5f5f0]">
                  {t.author}
                </div>
                <div className="mt-1 text-[10px] uppercase tracking-[0.22em] text-[#8a8a8a]">
                  {t.role}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
